<template lang="html">
  <footer id="footer">
    <section class="top-section">
      <div class="container med-container content">
        <div class="row">
          <div class="col-sm-6 col-lg-3 col-info">
            <div class="col col-icon">
              <i class="fa-light fa-store"></i>
            </div>
            <div class="col col-text">
              <h6>Visita nuestra tienda</h6>

              <div class="box x-small">
                <p>
                  Calle 10A #1795 C.P. 44440, Col. Ferrocarril<br />
                  Guadalajara, Jalisco. 
                </p>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-lg-3 col-info">
            <div class="col col-icon">
              <i class="fa-light fa-calendar-clock"></i>
            </div>
            <div class="col col-text">
              <h6>Abrimos Lunes a Sábado</h6>
              
              <div class="box x-small">
                <p class="d-inline-block w-100">
                  Lunes a Viernes:<br />9:00 AM - 6:00 PM
                </p>
                <p class="d-inline-block w-100">
                  Sábado 9:00 AM - 1:00 PM 
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-3 col-info">
            <div class="col col-icon">
              <i class="fa-light fa-credit-card-front"></i>
            </div>
            <div class="col col-text">
              <h6>Diferentes formas de pago</h6>
              
              <div class="box">
                Visítanos y compra con tranquilidad
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-3 col-info">
            <div class="col col-icon">
              <i class="fa-light fa-books"></i>
            </div>
            <div class="col col-text">
              <h6>El mejor catálogo</h6>
              
              <div class="box x-small">
                Contamos con más de 100 tipos y tamaños de macetas
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="menu-section">
      <div class="container med-container">
  			<div class="row">
  				<div class="col-lg-7 col-xl-6 col-left text-center text-sm-left">
  					<div class="row">
              <div class="col-sm-5">
                <p>
                  <router-link to="/blog">Blog</router-link>
                </p>
                <p>
                  <router-link to="/contacto">Contacto</router-link>
                </p>
                <!-- <p>
                  <router-link to="/terminos-y-condiciones">Términos y condiciones</router-link>
                </p> -->
                <p>
                  <router-link to="/aviso-de-privacidad">Aviso de privacidad</router-link>
                </p>
              </div>

              <div class="col-sm-7 mt-3 mt-sm-0 text-center text-sm-right">
                <div class="box-networks">
                  <a class="t-150 btn-network fb" target="_blank" :href="$root.redes.facebook" v-if="$root.redes.facebook"><i class="fab fa-facebook-f"></i></a>
                  <!-- <a class="t-150 btn-network tw" target="_blank" href="https://x.com/PpiInfo"><i class="fa-brands fa-x-twitter"></i></a> -->
                  <a class="t-150 btn-network ig" target="_blank" :href="$root.redes.instagram" v-if="$root.redes.instagram"><i class="fab fa-instagram"></i></a>
                  <a class="t-150 btn-network tk" target="_blank" :href="$root.redes.tiktok" v-if="$root.redes.tiktok"><i class="fa-brands fa-tiktok"></i></a>
                  <!-- <a class="t-150 btn-network wa" target="_blank" href=""><i class="fa-brands fa-whatsapp"></i></a> -->
                  <!-- <a class="t-150 btn-network lk" target="_blank" href=""><i class="fab fa-linkedin-in"></i></a> -->
                  <a class="t-150 btn-network yt" target="_blank" :href="$root.redes.youtube" v-if="$root.redes.youtube"><i class="fa-brands fa-youtube"></i></a>
                </div>

                <h6 class="title">© Procesos Plásticos Inyectados S.A de C.V. {{ currentYear }}</h6>
                <!-- <span class="address">
                  Calle 123
                </span> -->

                <!-- <span class="mt-2 copyright">© Empaques Tonalá {{ currentYear }}</span> -->
              </div>
            </div>
  				</div>

  				<div class="col-lg-5 col-xl-6 mt-4 mt-lg-0 col-footer col-right">
            <b-form @submit="onSubmit">
              <b-form-group class="custom-f-group-s1">
                <b-form-input
                  v-model="formNewsletter.email"
                  type="email"
                  placeholder="INSCRIBETE A NUESTRO NEWSLETTER"
                  required
                ></b-form-input>
              </b-form-group>
              <b-button type="submit" class="btn-send"></b-button>
            </b-form>
          </div>
  			</div>
    	</div>
    </section>

  </footer>
</template>

<script>
export default {
  data() {
    return {
      currentYear: 0,

      formNewsletter: {
        email: '',
      },
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
  },

  beforeMount() {
    this.currentYear = new Date().getFullYear();
  },
}
</script>
